import { Component } from '@angular/core';
import { ChildrenOutletContexts } from '@angular/router';
import { LayoutService } from '@app/layout/layout.service';
import { PageLayout as PageLayoutEnum } from '@app/layout/layout.service';
import { MessagingService } from '@app/services/messaging.service';
import { NotificationInboxService } from '@app/services/notification-inbox.service';
import { WakeSyncService } from '@app/services/wake-sync.service';
import { ThemeService } from '@app/services/theme.service';
import { getMessaging, onMessage } from 'firebase/messaging';
import { messagingInstance$ } from '@angular/fire/messaging';
import { SwPush } from '@angular/service-worker';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'prowodo';

  PageLayout = PageLayoutEnum;

  constructor(
    private contexts: ChildrenOutletContexts,
    public layoutService: LayoutService,
    private firebaseMessagingService: MessagingService,
    private notificationInboxService: NotificationInboxService,
    private wakeSync: WakeSyncService,
    private themeService: ThemeService,
    readonly swPush: SwPush
  ) {}

  ngOnInit() {
    onMessage(
      this.firebaseMessagingService.firebaseMessaggingApp,
      (payload) => {
        console.log('Message received. webpush firebase', payload);
        // const img = "/to-do-notifications/img/icon-128.png";
        // const text = `HEY! Your task "${title}" is now overdue.`;

        let option: any = {
          body: payload.notification?.body || '',
          // icon: img
        };
        if (payload.notification?.image) {
          option['image'] = payload.notification.image;
        }
        if (payload.notification?.icon) {
          option['icon'] = payload.notification.icon;
        }
        if (payload?.data) {
          option['data'] = payload.data;
        }
        if (payload?.fcmOptions) {
          let fcmOptions = payload.fcmOptions;
          if (fcmOptions?.link) {
            option['data'] = {
              ...option['data'],
              link: fcmOptions.link,
            };
          }
        }
        //   let fcmOptions = payload.fcmOptions;
        //   if (fcmOptions?.link) {
        //     option['data'] = {
        //       ...option['data'],
        //       link: fcmOptions.link,
        //       link_button1: fcmOptions.link_button1,
        //       link_button2: fcmOptions.link_button2,
        //       action_button1: fcmOptions.action_button1,
        //       action_button2: fcmOptions.action_button2,
        //     };
        //   }
        //   if (fcmOptions?.actions) {
        //     option['actions'] = fcmOptions.actions.map((action: any) => ({
        //       action: action.action,
        //       title: action.title,
        //       icon: action.icon || '/assets/icons/notification-icon.png',
        //     }));
        //   }
        // }

        // this.swPush.messages.subscribe((message) => {
        //   console.log('Message received. webpush:', message);
        // });
        this.notificationInboxService.load();

        const notification = new Notification(
          payload.notification?.title || 'Prowodo Notification',
          option
        );

        notification.onshow = (event) => {
          console.log('Notification shown:', event);
          // debugger;
        };

        notification.onclose = (event) => {
          console.log('Notification close:', event);
          // debugger;
        };

        notification.onclick = (event) => {
          console.log('Notification clicked:', event);
          // debugger;
          event.preventDefault(); // prevent the browser from focusing the Notification's tab

          let notificationData: any = {};
          let targetUrl: string | undefined = undefined;
          if (event.target && event.target instanceof Notification) {
            const notification: Notification = event.target;
            notificationData = notification.data || {};
            targetUrl = notificationData.link; // Default to the main link
          }

          // if (
          //   clickedAction === 'action_button1' &&
          //   notificationData.link_button1
          // ) {
          //   targetUrl = notificationData.link_button1;
          // } else if (
          //   clickedAction === 'action_button2' &&
          //   notificationData.link_button2
          // ) {
          //   targetUrl = notificationData.link_button2;
          // }

          if (targetUrl) {
            // event.waitUntil(clients.openWindow(targetUrl));
            window.open(
              targetUrl.replace('https://localhost:', 'http://localhost:'),
              '_blank'
            );
          }

          // if (payload?.fcmOptions) {
          //   let fcmOptions = payload.fcmOptions;
          //   if (fcmOptions?.link) {
          //     notification.onclick = () =>
          //       window.open(fcmOptions.link, '_blank');
          //     // window.open(payload.notification['click_action'] || '/', '_blank');
          //     notification.close();
          //   }
          // }
        };

        // document.addEventListener(
        //   "visibilitychange", () => {
        //     if (document.visibilityState === "visible") {
        //       // The tab has become visible so clear the now-stale Notification.
        //       notification.close();
        //     }
        //   }
        // );
      }
    );
    // let messaging = this.firebaseMessagingService.firebaseMessaggingApp
    // messagingInstance$.subscribe((messaging) => {
    // // this.angularFireMessaging.messaging.subscribe((messaging) => {
    //   messaging.onMessage((message) => {
    //     console.log('Message received fCM:', message);
    //     // Handle the received message here
    //   });
    // });
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'animation'
    ];
  }
}
